/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TextTemplateType } from './TextTemplateType';
import {
    TextTemplateTypeFromJSON,
    TextTemplateTypeFromJSONTyped,
    TextTemplateTypeToJSON,
} from './TextTemplateType';

/**
 * 
 * @export
 * @interface FindAllTextTemplateTypes200Response
 */
export interface FindAllTextTemplateTypes200Response {
    /**
     * 
     * @type {Array<TextTemplateType>}
     * @memberof FindAllTextTemplateTypes200Response
     */
    data?: Array<TextTemplateType>;
}

/**
 * Check if a given object implements the FindAllTextTemplateTypes200Response interface.
 */
export function instanceOfFindAllTextTemplateTypes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllTextTemplateTypes200ResponseFromJSON(json: any): FindAllTextTemplateTypes200Response {
    return FindAllTextTemplateTypes200ResponseFromJSONTyped(json, false);
}

export function FindAllTextTemplateTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllTextTemplateTypes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TextTemplateTypeFromJSON)),
    };
}

export function FindAllTextTemplateTypes200ResponseToJSON(value?: FindAllTextTemplateTypes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TextTemplateTypeToJSON)),
    };
}

